import RichText from '../RichText';
import jQuery from 'jquery';
export default class Page {
    constructor() {
        this.$pageContent = jQuery('[data-template-page]');
        if (this.$pageContent.length) {
            new RichText(this.$pageContent);
        }
    }
}
